import { osmAddressLines } from "./address.ts";
import { contactLinks } from "./contact.ts";
import { displayName } from "./identity.ts";
import { osmPlaceKind } from "./poi.ts";
import type { OsmProfile, OsmTags } from "./types.ts";

export function osmProfile(tags: OsmTags): OsmProfile {
  const placeKind = osmPlaceKind(tags);
  return {
    ...contactLinks(tags),
    name: displayName(tags),
    typeLabel: placeKind?.typeLabel,
    addressLines: osmAddressLines(tags),
    openingHours: tags["opening_hours"],
  };
}
